import {CA} from '../../analytics/Analytics.ts'
import {type AjaxDataTypes} from '../../../../../shared/AjaxDataTypes.ts'
import {AnalyticEventCategory, AnalyticEventType, AnalyticEventValue} from '../../../../../shared/entity_datas/EntityDatas.ts'
import {UIEndGameShareImage} from '../../ui_share_image/UIEndGameShareImage.ts'
import {UIEndGameTitleImage} from '../../ui_share_image/UIEndGameTitleImage.ts'
import {type UIGameManager} from '../UIGameManager.ts'
import {type UIGameEndController} from './UIGameEndController.ts'
import {ViewPopupShareImage} from '../../ui_popup/ViewPopupShareImage.ts'
import {UIUtilsEjsVariables} from '../../UIUtilsEjsVariables.ts'
import {UIReplayShareController} from '../../ui_replay/UIReplayShareController.ts'
import {type TranslationObject} from '@colonist/i18n'

export class UIGameEndShareButtonController {
    private readonly uiGameManager: UIGameManager
    private readonly gameEndController: UIGameEndController

    private shareImage?: UIEndGameShareImage
    private readonly titleImage?: UIEndGameTitleImage

    private shareImagePopup: ViewPopupShareImage

    constructor(uiGameManager: UIGameManager, gameEndController: UIGameEndController) {
        this.uiGameManager = uiGameManager
        this.gameEndController = gameEndController

        if(this.gameEndController.endGamePlayerState?.title != null) {
            this.titleImage = new UIEndGameTitleImage(this.uiGameManager, this.gameEndController.endGamePlayerState.title, this.gameEndController.endGameState)
        }

        if(this.shouldShowShareGameResultsPopupAutomaticallyOnGameEnd()) this.createShareImagePopupIfNotExist(true)
    }

    onClickShare() {
        this.createShareImagePopupIfNotExist()

        UIGameEndShareButtonController.sendShareButtonClickAnalytic()
    }

    private createShareImagePopupIfNotExist(delay: boolean = false) {
        if(this.isPopupRemovedOrDoesNotExist()) {
            if(delay) {
                setTimeout(() => this.createShareImagePopupIfNotExist(), 3000)
                return
            }

            this.shareImage = new UIEndGameShareImage(this.uiGameManager, this.gameEndController.endGameState)

            const title = UIUtilsEjsVariables.isUserOnMobile ? {key: 'strings:game.endGame.shareImagePopup.mobile.title'} as TranslationObject : undefined
            const onReplayShare = this.getReplayShareAction()

            this.shareImagePopup = this.titleImage
                ? new ViewPopupShareImage(this.titleImage, this.shareImage, true, title, onReplayShare)
                : new ViewPopupShareImage(this.shareImage, undefined, false, title, onReplayShare)
        }
    }

    private isPopupRemovedOrDoesNotExist(): boolean {
        if(this.shareImagePopup == undefined) return true
        if(this.shareImagePopup.isPopupRemoved()) return true
        return false
    }

    private shouldShowShareGameResultsPopupAutomaticallyOnGameEnd(): boolean {
        if(this.uiGameManager.gameController.isReplay) return false
        if(UIUtilsEjsVariables.isUserOnDiscord) return true
        return false
    }

    private static sendShareButtonClickAnalytic() {
        const endGameShareEvent: AjaxDataTypes.AnalyticData = {
            type: AnalyticEventType.EndGameShareButton,
            category: AnalyticEventCategory.Virality,
            floatValue: AnalyticEventValue.EndGameShareButton,
        }
        void CA.sendAnalyticEventOnce(endGameShareEvent)
    }

    private getReplayShareAction(): (() => Promise<void>) | undefined {
        if(!UIUtilsEjsVariables.isUserOnMobile) return undefined

        return async() => {
            const replayControlsOnShare = this.uiGameManager.gameStore.getState().gameReplay.replayControls?.onShare
            if(replayControlsOnShare) return replayControlsOnShare()
            await UIReplayShareController.shareOrCopyLink(this.uiGameManager.gameController)
        }
    }
}
